/*
 * Ones Media — İbrahim chat widget (custom, uniform n8n proxy — K3 karar (a))
 * Designer / Senaryo B — 2026-07-01
 *
 * Native flowise-embed KULLANILMAZ. Widget n8n web webhook'una POST eder;
 * n8n lead marker'ı extract + strip + Kommo/mail dispatch yapar, temiz {reply} döner.
 * Marker kullanıcıya ASLA gitmez. WhatsApp/Instagram path'i ile uniform.
 *
 * İzolasyon: Shadow DOM (Shopify tema CSS'i etkilenmez).
 * Neon/glow YASAK (Anayasa §0): ışıma/halo/glow yok — katı renk + hairline + renksiz elevation.
 *
 * Embed: <script defer src=".../ones-media-chat-widget.js"></script>  (</body> öncesi)
 */
(function () {
  "use strict";

  // ── Config ────────────────────────────────────────────────────────────────
  var CONFIG = {
    // ⚠️ Kurulumcu web webhook'unu canlıya alınca doğrula (contract: widget_integration.md §2.1)
    endpoint: "https://n8n.websmen.com/webhook/ones-media-web-inbound",
    channel: "web",
    sidKey: "omc_chat_sid",
    title: "İbrahim — Ones Media",
    subtitle: "Tablo & koleksiyon danışmanı",
    welcome: "Merhaba! Ben İbrahim 👋 Ones Media tablo ve koleksiyonları hakkında size yardımcı olabilirim. Ne aramıştınız?",
    placeholder: "Mesajınızı yazın…",
    errorMsg: "Şu an bağlanılamadı, birazdan tekrar deneyin. Dilerseniz WhatsApp'tan da yazabilirsiniz.",
    timeoutMs: 45000,
  };

  if (window.__omcWidgetLoaded) return; // çift-yükleme koruması
  window.__omcWidgetLoaded = true;

  // ── sessionId (ziyaretçi başına kalıcı) ────────────────────────────────────
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0, v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
  function sessionId() {
    var sid;
    try { sid = localStorage.getItem(CONFIG.sidKey); } catch (e) { sid = null; }
    if (!sid) {
      sid = "web_" + uuid();
      try { localStorage.setItem(CONFIG.sidKey, sid); } catch (e) {}
    }
    return sid;
  }

  // ── Shadow host ────────────────────────────────────────────────────────────
  var host = document.createElement("div");
  host.setAttribute("id", "omc-chat-widget");
  document.body.appendChild(host);
  var root = host.attachShadow({ mode: "open" });

  var STYLE = "" +
    ":host{all:initial}" +
    "*{box-sizing:border-box;font-family:system-ui,-apple-system,Segoe UI,Roboto,sans-serif}" +
    ".omc-wrap{position:fixed;right:24px;bottom:max(24px,env(safe-area-inset-bottom));z-index:90;" +
      "--ink:#1a1712;--surface:#faf7f2;--surface2:#fff;--line:#e7e0d6;--accent:#8a5a2b;--accent-ink:#fff}" +
    // Launcher — katı renk daire, glow YOK, sadece renksiz elevation
    ".omc-launcher{width:60px;height:60px;border-radius:999px;border:0;cursor:pointer;background:var(--accent);" +
      "color:var(--accent-ink);display:flex;align-items:center;justify-content:center;" +
      "box-shadow:0 4px 18px -12px rgba(26,23,20,.12);transition:transform .16s ease}" +
    ".omc-launcher:hover{transform:translateY(-2px)}" +
    ".omc-launcher:focus-visible{outline:2px solid var(--ink);outline-offset:3px}" +
    ".omc-launcher svg{width:26px;height:26px}" +
    // Panel — hairline kenarlık + ton merdiveni + renksiz elevation
    ".omc-panel{position:absolute;right:0;bottom:74px;width:370px;max-width:calc(100vw - 32px);height:540px;" +
      "max-height:calc(100dvh - 120px);background:var(--surface);border:1px solid var(--line);border-radius:16px;" +
      "box-shadow:0 12px 40px -18px rgba(26,23,20,.22);display:flex;flex-direction:column;overflow:hidden;" +
      "opacity:0;transform:translateY(8px);pointer-events:none;transition:opacity .16s ease,transform .16s ease}" +
    ".omc-panel.open{opacity:1;transform:none;pointer-events:auto}" +
    // Header — katı accent blok
    ".omc-head{background:var(--accent);color:var(--accent-ink);padding:14px 16px;display:flex;align-items:center;gap:10px}" +
    ".omc-head .t{font-weight:600;font-size:15px;line-height:1.2}" +
    ".omc-head .s{font-size:12px;opacity:.85;line-height:1.3}" +
    ".omc-close{margin-inline-start:auto;background:transparent;border:0;color:var(--accent-ink);cursor:pointer;" +
      "width:32px;height:32px;border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:20px}" +
    ".omc-close:hover{background:rgba(255,255,255,.14)}" +
    ".omc-close:focus-visible{outline:2px solid var(--accent-ink);outline-offset:2px}" +
    // Mesaj alanı
    ".omc-body{flex:1;overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:10px}" +
    ".omc-msg{max-width:82%;padding:10px 13px;border-radius:12px;font-size:14px;line-height:1.45;white-space:pre-wrap;word-wrap:break-word}" +
    ".omc-bot{align-self:flex-start;background:var(--surface2);border:1px solid var(--line);color:var(--ink)}" +
    ".omc-user{align-self:flex-end;background:var(--accent);color:var(--accent-ink)}" +
    ".omc-typing{align-self:flex-start;display:flex;gap:4px;padding:12px 14px;background:var(--surface2);border:1px solid var(--line);border-radius:12px}" +
    ".omc-typing span{width:6px;height:6px;border-radius:999px;background:var(--ink);opacity:.4;animation:omc-b 1s infinite}" +
    ".omc-typing span:nth-child(2){animation-delay:.15s}.omc-typing span:nth-child(3){animation-delay:.3s}" +
    "@keyframes omc-b{0%,100%{opacity:.25;transform:translateY(0)}50%{opacity:.7;transform:translateY(-3px)}}" +
    // Input
    ".omc-foot{border-top:1px solid var(--line);padding:10px;display:flex;gap:8px;align-items:flex-end;background:var(--surface)}" +
    ".omc-in{flex:1;resize:none;max-height:96px;border:1px solid var(--line);border-radius:10px;padding:10px 12px;" +
      "font-size:14px;line-height:1.4;color:var(--ink);background:var(--surface2)}" +
    ".omc-in:focus{outline:2px solid var(--accent);outline-offset:-1px}" +
    ".omc-send{border:0;background:var(--accent);color:var(--accent-ink);border-radius:10px;width:42px;height:42px;" +
      "cursor:pointer;display:flex;align-items:center;justify-content:center;flex:none}" +
    ".omc-send:disabled{opacity:.5;cursor:default}" +
    ".omc-send:focus-visible{outline:2px solid var(--ink);outline-offset:2px}" +
    ".omc-send svg{width:20px;height:20px}" +
    // Mobil — tam-genişlik alt sheet
    "@media (max-width:480px){.omc-wrap{right:0;bottom:0}.omc-launcher{margin:0 20px 20px 0;margin-inline-start:auto}" +
      ".omc-panel{position:fixed;right:0;left:0;bottom:0;width:100vw;max-width:100vw;height:85dvh;max-height:85dvh;" +
      "border-radius:16px 16px 0 0;border-bottom:0}}" +
    // Reduced motion
    "@media (prefers-reduced-motion:reduce){.omc-launcher,.omc-panel{transition:none}.omc-typing span{animation:none}}";

  var ICON_CHAT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>';
  var ICON_SEND = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>';

  // ── DOM ────────────────────────────────────────────────────────────────────
  var wrap = document.createElement("div");
  wrap.className = "omc-wrap";
  wrap.innerHTML =
    '<button class="omc-launcher" type="button" aria-label="Sohbeti aç" aria-expanded="false">' + ICON_CHAT + "</button>" +
    '<section class="omc-panel" role="dialog" aria-modal="false" aria-label="' + CONFIG.title + '" hidden>' +
      '<div class="omc-head"><div><div class="t">' + CONFIG.title + '</div><div class="s">' + CONFIG.subtitle + "</div></div>" +
        '<button class="omc-close" type="button" aria-label="Sohbeti kapat">&times;</button></div>' +
      '<div class="omc-body" role="log" aria-live="polite" aria-atomic="false"></div>' +
      '<div class="omc-foot">' +
        '<textarea class="omc-in" rows="1" aria-label="' + CONFIG.placeholder + '" placeholder="' + CONFIG.placeholder + '"></textarea>' +
        '<button class="omc-send" type="button" aria-label="Gönder">' + ICON_SEND + "</button>" +
      "</div>" +
    "</section>";

  var styleEl = document.createElement("style");
  styleEl.textContent = STYLE;
  root.appendChild(styleEl);
  root.appendChild(wrap);

  var launcher = root.querySelector(".omc-launcher");
  var panel = root.querySelector(".omc-panel");
  var closeBtn = root.querySelector(".omc-close");
  var body = root.querySelector(".omc-body");
  var input = root.querySelector(".omc-in");
  var sendBtn = root.querySelector(".omc-send");

  var welcomed = false, busy = false;

  // ── Render helpers ──────────────────────────────────────────────────────────
  function esc(s) {
    var d = document.createElement("div"); d.textContent = String(s); return d.innerHTML;
  }
  function addMsg(text, who) {
    var el = document.createElement("div");
    el.className = "omc-msg " + (who === "user" ? "omc-user" : "omc-bot");
    el.innerHTML = esc(text); // XSS-safe: textContent tabanlı
    body.appendChild(el);
    body.scrollTop = body.scrollHeight;
    return el;
  }
  function showTyping() {
    var t = document.createElement("div");
    t.className = "omc-typing"; t.setAttribute("aria-label", "yazıyor");
    t.innerHTML = "<span></span><span></span><span></span>";
    body.appendChild(t); body.scrollTop = body.scrollHeight;
    return t;
  }

  // ── Open / close ────────────────────────────────────────────────────────────
  function open() {
    panel.hidden = false;
    // reflow → transition
    void panel.offsetWidth;
    panel.classList.add("open");
    launcher.setAttribute("aria-expanded", "true");
    if (!welcomed) { addMsg(CONFIG.welcome, "bot"); welcomed = true; }
    setTimeout(function () { input.focus(); }, 60);
  }
  function close() {
    panel.classList.remove("open");
    launcher.setAttribute("aria-expanded", "false");
    setTimeout(function () { panel.hidden = true; }, 180);
    launcher.focus();
  }

  launcher.addEventListener("click", function () {
    panel.classList.contains("open") ? close() : open();
  });
  closeBtn.addEventListener("click", close);
  root.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && panel.classList.contains("open")) close();
  });

  // ── Input auto-grow + Enter ─────────────────────────────────────────────────
  input.addEventListener("input", function () {
    input.style.height = "auto";
    input.style.height = Math.min(input.scrollHeight, 96) + "px";
  });
  input.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); }
  });
  sendBtn.addEventListener("click", send);

  // ── Send → n8n web webhook ──────────────────────────────────────────────────
  function send() {
    var text = input.value.trim();
    if (!text || busy) return;
    addMsg(text, "user");
    input.value = ""; input.style.height = "auto";
    busy = true; sendBtn.disabled = true;
    var typing = showTyping();

    var ctrl = new AbortController();
    var to = setTimeout(function () { ctrl.abort(); }, CONFIG.timeoutMs);

    fetch(CONFIG.endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ question: text, sessionId: sessionId(), channel: CONFIG.channel }),
      signal: ctrl.signal,
    })
      .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .then(function (data) {
        var reply = (data && (data.reply || data.text || data.answer)) || "";
        typing.remove();
        addMsg(reply || CONFIG.errorMsg, "bot");
      })
      .catch(function () {
        typing.remove();
        addMsg(CONFIG.errorMsg, "bot");
      })
      .then(function () {
        clearTimeout(to); busy = false; sendBtn.disabled = false; input.focus();
      });
  }
})();